import { render } from "./HeaderAdmin.vue?vue&type=template&id=b5f43686&scoped=true"
import script from "./HeaderAdmin.vue?vue&type=script&lang=js"
export * from "./HeaderAdmin.vue?vue&type=script&lang=js"

import "./HeaderAdmin.vue?vue&type=style&index=0&id=b5f43686&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f43686"]])

export default __exports__